import { pipe } from 'fp-ts/function';
import { FC } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { Amount, ApplicationState } from '@mews-commander/types';
import { SpacingMediumTopBottom } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { LocalizedText, withScopeContext } from '@mews/framework';
import { AmountDue } from '../../AmountDue';
import { getSelectedOrderItemsTotalAmount } from '../../selectors';

interface RebateSumOwnProps {
    billId: string;
    scope: string;
}

interface RebateSumStateProps {
    rebateSum: Amount;
}

type RebateSumProps = RebateSumOwnProps & RebateSumStateProps;

const RebateSum: FC<RebateSumProps> = ({ rebateSum }) => (
    <SpacingMediumTopBottom>
        <Stack distribution="space-between" alignment="center" data-test-id={DataTestId.RebatesSum}>
            <LocalizedText textKey={TextKey.TotalRebate} />
            <AmountDue isNegative={false} value={rebateSum} />
        </Stack>
    </SpacingMediumTopBottom>
);

export default withScopeContext(
    pipe(
        RebateSum,
        connect<RebateSumStateProps, {}, RebateSumOwnProps, ApplicationState>(
            createStructuredSelector({
                rebateSum: getSelectedOrderItemsTotalAmount,
            })
        )
    )
);
